

<div>
  <fieldset class="form-group">
    <div class="row align-items-end mt-0 pagination-body">

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
            <div class="btn-group enrollment-list-btn-info" role="group">
              <button class="btn mb-2" *ngFor="let item of task_status_list"
                [ngClass]="{'btn-primary':activeTab==item?.name,'btn-outline-primary':activeTab!=item?.name}"
                (click)="activeStatusTab(item?.name)">
                {{item?.displayname}}
              </button>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
            <div class="row-flex">
               
                <div class="col-flex-2 mb-1 position-relative" placement="top"
                    ngbTooltip="search by  name,email,phone,pan,account number,empcode">
                    <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                        (keydown.enter)="filterTask(searchVal)" />
                    <button class="btn search-btn glow position-absolute"
                        (click)="filterTask(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                    </button>
                </div>
                <div class="col-flex-2 mb-1">
                    <button class="btn btn-primary btn-block users-list-clear glow mb-0"
                        (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                    </button>
                </div>
                <div class="col-flex-2 mb-1">
                    <button type="button" (click)="openModal(myModal)"
                        class="btn btn-primary btn-block users-list-clear glow mb-0"
                       placement="bottom" ngbTooltip="Add New">
                        +
                    </button>
                </div>
                <div class="col-flex-2 mb-1"
                    >
                    <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0" placement="bottom"
                        ngbTooltip="Add New Demo"  (click)="openModal(demoTask_modal)">
                        + Demo
                    </button>
                </div>
                <!-- <button class="btn btn-primary btn-block mb-2 mt-1" (click)="openModal(myModal)"><i
                  class="ft-plus mr-2"></i>Create Task</button>
              <button class="btn btn-primary btn-block mb-2 mt-1" (click)="openModal(demoTask_modal)"><i
                  class="ft-plus mr-2"></i>Create Demo</button> -->

            </div>
        </div>
    </div>
    <div class="row  mt-0 pagination-body">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12  ">
        <div class="row-flex filter-tabs">
          <div class="col-flex-2 filter">
            <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select User"
              [(ngModel)]="selected_user_id" [ngModelOptions]="{ standalone: true }"
              (change)="getUserId($event)">
            </ng-select>
          </div>
          <div class="col-flex-2 filter">
            <ng-select [items]="task_priority_List" bindLabel="displayname" bindValue="_id"
              placeholder="Select User" [(ngModel)]="selected_priority_id"
              [ngModelOptions]="{ standalone: true }" (change)="getPriorityId($event)">
            </ng-select>
          </div>
          <div class="col-flex-2 filter">
            <ng-select [items]="scheduleList" bindLabel="name" bindValue="id" placeholder="Select Schedule"
              [(ngModel)]="selectedSchedule_filter" [ngModelOptions]="{ standalone: true }" (change)="getChangeScheduleId($event)">
            </ng-select>
          </div>
          <div class="col-flex-2 filter">
            <ng-select [items]="task_stage_list" bindLabel="displayname" bindValue="_id"
              placeholder="Select User" [(ngModel)]="selected_stage_id"
              [ngModelOptions]="{ standalone: true }" (change)="getStageId($event)">
            </ng-select>
          </div>
         
        </div>
      </div>
    </div>
</fieldset>
</div>


<div class="email-application  overflow-hidden">
  <div #contentOverlay class="app-content-overlay" [ngClass]="{show: isContentOverlay}" (click)="onContentOverlay()">
  </div>
  <div #emailSidebar class="email-app-sidebar d-xl-block" [ngClass]="{show: isEmailSidebarShow}">
    <span class="sidebar-close-icon d-xl-none" (click)="isContentOverlay = false; isEmailSidebarShow = false;">
      <i class="ft-x"></i>
    </span>
    <div [perfectScrollbar] class="email-app-sidebar-content">
  
      <div class="email-app-menu">
          <button class="btn btn-primary btn-block" (click)="openFilterModal(filterModal)">Save Filter</button>
        <hr class="my-2">
        <span class="grey my-2 d-block font-small-3 text-uppercase">Filters</span>
          <div class="list-group list-group-messages border-0">
            <a class="list-group-item list-group-item-action border-0 d-flex justify-content-between"
               *ngFor="let item of saved_filter_list; let i = index"
               [ngClass]="{'active': activeFilterIndex === i}"
               (click)="getSavedFilterId(item, i)">
              <div class="d-flex align-items-center">
                <i class="ft-circle warning font-small-1 mr-2"></i>
                <span *ngIf="!item?.title">{{ i +1 }} Filter</span>
                <span *ngIf="item?.title">{{ item?.title }}</span>
              </div>
            </a>
          </div>
       
      </div>
    </div>
  </div>
  <div class="email-app-content row">
    <div class="email-search-box w-100 p-2">
      <div class="media px-2 d-flex align-items-center">
        <span class="email-app-sidebar-toggle ft-menu cursor-pointer font-large-1 mr-3 d-xl-none"
          (click)="onSidebarToggle()"></span>
        <div class="media-body pr-1">
          <input #name type="text" class="form-control" placeholder="Search for emails" [(ngModel)]="searchQuery" (keydown.enter)="filterTask(searchQuery)">
        </div>
      </div>
    </div>
    <div class="task-count">
      <p>total : {{task_data?.length}}</p>
    </div>
    <div class="email-app-content-area w-100">
      <div class="email-app-list-mails p-0" (click)="onListItemClick()">
        <div [perfectScrollbar] class="email-app-list">
          <div id="users-list">
            <div class="list-group">
              <div class="users-list-padding">
                <div class="list-group-item list-group-item-action">
                  <div class=" media email-list-text p-0 mb-3" *ngFor="let task of task_data">
                    <span class="avatar {{mail.imageClass}} mr-2">
                      <span *ngIf="!mail.hasImage" class="avatar-content">{{
                        task?.title | shortName }}</span>
                    </span>
                    <div class="media-body">
                      <h6 class="list-group-item-heading">
                        <!-- <span *ngFor="let user of task?.to ; last as isLast"> 
                            {{ user?.name }} 
                            <span *ngIf="task?.to.length>1 && !isLast">,</span>
                          </span>
                          -->
                        <span *ngFor="let user of task?.to; let i = index; last as isLast">
                          <span *ngIf="i === 0" (click)="getSelectedTask(task?._id)">{{ user.name }}</span>

                          <!-- Display '+ more' if there are additional names -->
                          <span class="badge badge-pill ml-1" *ngIf="i === task?.to.length - 1 && task?.to.length > 1">+
                            more {{ task?.to.length - 1 }}</span>
                        </span>

                      </h6>
                      <div class="d-flex justify-content-between">
                        <p
                          [ngClass]="mail.isRead === false ? 'list-group-item-text text-truncate text-bold-500' : 'list-group-item-text text-truncate' ">
                          {{
                          task?.title }}</p>
                        <span class="float-right">
                          <i class="ft-paperclip mr-1" *ngIf="mail.hasAttachment"></i>
                          <span
                            [ngClass]="mail.isRead === false ? 'email-list-text font-small-2 email-time text-bold-400' : 'email-list-text font-small-2 email-time'">{{
                            task.updated_at | date:'shortTime' }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <a class="list-group-item list-group-item-action"
                    [ngClass]="{'selected-email': mail.mailId == selectedMailId, 'border-0': mail.mailId != selectedMailId}"
                    *ngFor="let mail of mail | search:'mailFrom,subject,body':searchQuery"
                    (click)="DisplayMessage([mail.mailId])">
                    <div class="media email-list-text p-0">
                      <span class="avatar {{mail.imageClass}} mr-2">
                        <span *ngIf="!mail.hasImage" class="avatar-content">{{
                          mail.imageText }}</span>
                        <img *ngIf="mail.hasImage" width="32" height="32" [src]="mail.imagePath" alt="avatar">
                      </span>
                      <div class="media-body">
                        <h6 class="list-group-item-heading">
                          <span> {{ mail.mailFrom }} </span>
                          <span class="float-right">
                            <i class="ft-paperclip mr-1" *ngIf="mail.hasAttachment"></i>
                            <span
                              [ngClass]="mail.isRead === false ? 'email-list-text font-small-2 email-time text-bold-400' : 'email-list-text font-small-2 email-time'">{{
                              mail.time }}</span>
                          </span>
                        </h6>
                        <p
                          [ngClass]="mail.isRead === false ? 'list-group-item-text text-truncate text-bold-500' : 'list-group-item-text text-truncate' ">{{
                          mail.subject }}</p>
                        <p class="list-group-item-text">{{ mail.body }}
                          <span class="float-right" *ngIf="mail.hasLabel">
                            <span class="badge m8r-1 {{mail.labelClass}}">{{
                              mail.labelType }}</span>
                            <i *ngIf="isEmailImportant" class="font-medium-1 ft-star warning"></i>
                            <i *ngIf="!isEmailImportant" class="font-medium-1 ft-star"></i> -->
                <!-- <i [ngClass]="mail.isImportant === false ? 'font-medium-1 ft-star blue-grey lighten-3' : 'font-medium-1 ft-star warning'"></i> -->
                <!-- </span>
                          <span class="float-right primary" *ngIf="!mail.hasLabel">
                            <i class="font-medium-1 ft-star blue-grey lighten-3"></i>
                          </span>
                        </p>
  
                      </div>
                    </div>
                  </a> -->
                <p class="primary text-center" *ngIf="mail.length === 0">There are no messages!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="email-app-mail-content" *ngIf="isCurrentTask" [ngClass]="{'show-email-content': isMessageSelected}">
        <div class="email-app-mail-content-detail px-4 py-3 py-md-1" [perfectScrollbar] *ngIf="isMessageSelected">
          <div class="email-app-options">
            <div class="row d-md-none">
              <button class="btn btn-primary ml-2 back-to-inbox mb-2" (click)="OnBackToInbox()">
                <i class="ft-chevron-left mr-2"></i> Back to inbox</button>
            </div>
            <div class="row">
              <div class="col-sm-6 col-12 text-left">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Replay">
                    <i class="ft-corner-up-left font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Replay All">
                    <i class="ft-chevrons-left font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Report SPAM">
                    <i class="ft-alert-octagon font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Delete">
                    <i class="ft-trash-2 font-small-3"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-6 col-12 text-right">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Previous">
                    <i class="ft-chevron-left font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Next">
                    <i class="ft-chevron-right font-small-3"></i>
                  </button>
                </div>
                <div class="btn-group ml-1">
                  <div ngbDropdown display="dynamic" [placement]="placement" class="d-inline-block">
                    <button class="btn btn-sm bg-light-secondary dropdown-toggle" id="dropdownBasic1"
                      ngbDropdownToggle>More</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <div class="task-status-box" *ngFor="let item of task_status_list">
                        <button class="dropdown-item" (click)="updateStatus(item?._id,current_task_data?._id)">{{item.displayname}}</button>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="email-app-title card-body px-0">
            <div class="title-box d-flex justify-content-between">
              <h3 class="list-group-item-heading">{{current_task_data?.title}}</h3>
              <p [ngClass]="{'bg-light-info badge ': current_task_data?.label?.displayname =='Assignment'}"
                *ngIf="current_task_data?.label?.displayname =='Assignment'">{{current_task_data?.label?.displayname}}</p>
              <p [ngClass]="{'bg-light-warning badge': current_task_data?.label?.displayname =='Events'}"
                *ngIf=" current_task_data?.label?.displayname =='Events'">{{current_task_data?.label?.displayname}}</p>
              <p [ngClass]="{'bg-light-danger badge ': current_task_data?.label?.displayname =='Leave'}"
                *ngIf="current_task_data?.label?.displayname =='Leave'">{{current_task_data?.label?.displayname}}</p>
              <p [ngClass]="{'bg-light-primary badge': current_task_data?.label?.displayname =='Demo'}" *ngIf="current_task_data?.label?.displayname =='Demo'">
                {{current_task_data?.label?.displayname}}</p>
            </div>
            
            <!-- <p class="list-group-item-text">
                <span class="primary">
                  <span class="badge bg-light-primary">Previous</span>
                  <i *ngIf="isEmailImportant" class="float-right font-medium-3 ft-star warning"></i>
                  <i *ngIf="!isEmailImportant" class="float-right font-medium-3 ft-star"></i>
                </span>
              </p> -->
            <div class="card-content">
              <div class="email-app-text card-body py-0">
                <div class="user-box">
                  <span class="user-chips" *ngFor="let user of current_task_data?.to; last as isLast">
                    <span class="badge badge-pill">{{user?.name}}</span>
                    <!-- <span *ngIf="current_task_data?.to.length>1 && !isLast">,</span> -->
                  </span>
                </div>
                <div class="checklist-box">
                  <span class="badge badge-pill bg-light-info">{{current_task_data?.type_checklist?.displayname}}</span>
                </div>
                <div class="email-app-message mt-2">
                  <div [innerHTML]="current_task_data?.body">
                  </div>
                  <!-- <div *ngIf="messageDetail.hasAttachment">
                      <p class="primary">Attachments:</p>
                      <div *ngFor="let attachment of messageDetail.attachments" class="float-left mr-2">
                        <img class="media-object width-100" [src]="attachment.url" alt="Generic placeholder image">
                      </div>
                    </div> -->
                </div>
              </div>
            </div>
          </div>

          <!-- <div *ngFor="let messageDetail of message.messages">
              <div id="headingCollapse2" class="card-header p-0">
                <a (click)="messageDetail.collapsed = !messageDetail.collapsed"
                  [attr.aria-expanded]="!messageDetail.collapsed" [attr.aria-controls]="messageDetail.messageId"
                  [ngClass]="{'collapsed': messageDetail.collapsed, 'opened-email': !messageDetail.collapsed}"
                  class=" email-app-sender list-group-item list-group-item-action border-0 ">
                  <div class="media">
                    <span class="avatar {{messageDetail.avatarClass}} mr-2">
                      <span *ngIf="!messageDetail.hasAvatar" class="avatar-content">{{
                          messageDetail.avatarText }}</span>
                      <img *ngIf="messageDetail.hasAvatar" width="32" height="32" alt="avatar"
                        [src]="messageDetail.avatarPath">
                    </span>
                    <div class="media-body">
                      <h6 class="list-group-item-heading">{{messageDetail.mailFrom}}</h6>
                      <p class="list-group-item-text  m-0">to {{messageDetail.mailTo}}
                        <span class="float-right text muted" *ngIf="messageDetail.collapsed">{{messageDetail.time}}</span>
                        <span class="float-right" *ngIf="!messageDetail.collapsed">
                          <i class="ft-corner-up-left mr-1"></i>
                          <i class="ft-arrow-right mr-1"></i>
                          <i class="ft-more-vertical-"></i>
                        </span>
                      </p>
  
                    </div>
                  </div>
                </a>
              </div>
              <div [id]="messageDetail.messageId" [ngbCollapse]="messageDetail.collapsed">
                <div class="card-content">
                  <div class="email-app-text card-body py-0">
                    <div class="email-app-message mt-2">
                      <div [innerHTML]="messageDetail.body">
                      </div>
                      <div *ngIf="messageDetail.hasAttachment">
                        <p class="primary">Attachments:</p>
                        <div *ngFor="let attachment of messageDetail.attachments" class="float-left mr-2">
                          <img class="media-object width-100" [src]="attachment.url" alt="Generic placeholder image">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="email-app-text-action card-content">
  
              </div>
            </div>
   -->
        </div>
        <div class="email-app-mail-content-detail" *ngIf="!isMessageSelected">
          <p class="primary text-center">Select a message to read</p>
        </div>
      </div>
    </div>
  </div>
  <div class="compose-new-mail-sidebar" [ngClass]="{show: isComposeShow}">
    <span class="compose-sidebar-close-icon" (click)="compose(false)">
      <i class="ft-x"></i>
    </span>
    <div class="card bg-transparent shadow-none quill-wrapper m-0">
      <div class="card-header">
        <h3 class="card-title">New Message</h3>
      </div>

      <form action="#" id="compose-form">
        <div class="card-content">
          <div class="card-body">
            <div class="form-group">
              <label for="compose-email-from">from</label>
              <input type="text" id="compose-email-from" class="form-control" placeholder="user@example.com" disabled>
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-to">To</label>
              <input type="email" id="compose-email-to" class="form-control" placeholder="To" required>
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-subject">Subject</label>
              <input type="text" id="compose-email-subject" class="form-control" placeholder="Subject">
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-cc">CC</label>
              <input type="text" id="compose-email-cc" class="form-control" placeholder="CC">
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-bcc">BCC</label>
              <input type="text" id="compose-email-bcc" class="form-control" placeholder="BCC">
            </div>

            <div class="snow-container border rounded">

              <quill-editor customToolbarPosition="bottom" format="object">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-link"></button>
                    <button class="ql-image"></button>
                  </span>
                </div>
              </quill-editor>
            </div>
            <div class="form-group mt-2">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="compose-email-attach">
                <label class="custom-file-label" for="compose-email-attach">Attach file</label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end pt-0">
          <button type="reset" class="btn bg-light-secondary compose-cancel-btn mr-2">
            <i class='ft-x m-0 mr-sm-1'></i>
            <span class="d-sm-inline-block d-none">Cancel</span>
          </button>
          <button type="submit" class="btn-send btn btn-primary">
            <i class='ft-send m-0 mr-sm-1'></i>
            <span class="d-sm-inline-block d-none">Send</span>
          </button>
        </div>
      </form>

    </div>
  </div>
</div>

<!-------- Create Task ------------------------- -->

<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h3>Create Task</h3>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-body taskboard-modal">
        <form [formGroup]="myForm">
          <div class="container">
            <div class="d-flex icons-list">
              <div class="dropdown mr-2">
                <i class="fa-solid fa-user-tie fa-xl cursor-pointer" *ngIf="task_for_selected =='employee'"
                  placement="top" [ngClass]="{'active-icon': task_for_selected =='employee' }"
                  [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen"></i>
                <i class="fa-solid fa-user-graduate fa-xl cursor-pointer" *ngIf="task_for_selected =='student'"
                  placement="top" [ngClass]="{'active-icon': task_for_selected =='student' }"
                  [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen"></i>
                <div class="dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="dropdownMenuButton">
                  <span class="dropdown-item" (click)="toggleActiveStudent('student'); isDropdownOpen = false">
                    <span class="active-tab cursor-pointer">Student</span>
                  </span>
                  <span class="dropdown-item" (click)="toggleActiveStudent('emp'); isDropdownOpen = false">
                    <span class="active-tab cursor-pointer">Employee</span>
                  </span>
                </div>
              </div>
              <div class="dropdown mr-1">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isStudentList}"
                  placement="top" ngbTooltip="individual" id="dropdownMenuButton2" data-toggle="dropdown"
                  *ngIf="isStudentList && !isBatchList && isStudent && !isEmployee"
                  (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <i class="fas fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isBatchList}" placement="top"
                  ngbTooltip="batch" id="dropdownMenuButton2" data-toggle="dropdown"
                  *ngIf="isBatchList && !isStudentList && isStudent && !isEmployee"
                  (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" *ngIf="isStudent"
                  [class.show]="isDropdownOpen_student">
                  <a class="dropdown-item" *ngIf="!isStudentList"
                    (click)="toggleActive('student-ind'); isDropdownOpen_student = false">Individual</a>
                  <a class="dropdown-item" *ngIf="!isBatchList"
                    (click)="toggleActive('student-batch') ; isDropdownOpen_student = false">Batch</a>
                </div>
              </div>
              <div class="dropdown mr-2">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isEmpList}" placement="top"
                  ngbTooltip="individual" id="dropdownMenuButton3" data-toggle="dropdown"
                  *ngIf="isEmpList && !isTeamList && !isStudentList && !isStudent && isEmployee"
                  (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <i class="fa-solid fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isTeamList}"
                  placement="top" ngbTooltip="team" id="dropdownMenuButton3" data-toggle="dropdown"
                  *ngIf="isTeamList && !isEmpList && !isStudentList && !isStudent && isEmployee"
                  (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3" *ngIf="isEmployee"
                  [class.show]="isDropdownOpen_employee">
                  <a class="dropdown-item" *ngIf="!isEmpList" (click)="toggleActive('emp-ind')">Individual</a>
                  <a class="dropdown-item" *ngIf="!isTeamList" (click)="toggleActive('emp-team')">Team</a>
                </div>
              </div>
              <div class="dropdown mr-2">
                <span class="icon mr-2 mb-2 cursor-pointer"
                  [ngClass]="{'active-icon': isScheduleList || selectedSchedule_filter}"
                  (click)="isScheduleList = !isScheduleList" placement="top" ngbTooltip="schedule" id="scheduleList"
                  data-toggle="dropdown"><i class="fa-solid fa-calendar-days fa-xl"></i></span>
                <div class="dropdown-menu hide-scroll" aria-labelledby="scheduleList">
                  <a class="dropdown-item" *ngFor="let item of scheduleList"
                    [class.active]="item.id === selectedSchedule_filter">
                    <span (click)="getChangeScheduleId($event)">{{item.name}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer"
                  [ngClass]="{'active-icon': isPriorityList || selected_task_priority}"
                  (click)="isPriorityList = !isPriorityList" placement="top" ngbTooltip="priority" id="priorityList"
                  data-toggle="dropdown"><i class="fa-solid fa-layer-group fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="priorityList">
                  <a class="dropdown-item" *ngFor="let item of task_priority_List"
                    [class.active]="item._id === selected_task_priority">
                    <span (click)="getChangeTaskPriority(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': selectedType}"
                (click)="isType = !isType" placement="top" ngbTooltip="Type"><i class="ft-grid fa-xl"></i></span>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isTaskLabel || selectedTaskLabel}"
                  (click)="isTaskLabel = !isTaskLabel" placement="top" ngbTooltip="task label" id="task_labelList"
                  data-toggle="dropdown"><i class="ft-tag fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="task_labelList">
                  <a class="dropdown-item" *ngFor="let item of taskLabelList"
                    [class.active]="item._id === selectedTaskLabel">
                    <span (click)="getChangeTaskLabelId(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer"
                  [ngClass]="{'active-icon-danger': isMandatory || selectedMandatory}"
                  (click)="isMandatory = !isMandatory" placement="top" ngbTooltip="mandatory" id="mandatoryList"
                  data-toggle="dropdown"><i class="ft-alert-circle fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="mandatoryList">
                  <a class="dropdown-item" *ngFor="let item of mandatoryList"
                    [class.active]="item.id === selectedMandatory">
                    <span (click)="getChangeMandatoryId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>

            </div>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isEmpList || isTeamList ">
              <ng-select *ngIf="!isTeam_selected_list" [items]="empList" bindLabel="name" bindValue="_id"
                placeholder="Select Employee" [(ngModel)]="selectedEmp" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenEmp($event)"
                (close)="onDropdownCloseEmp($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionEmp()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionEmp(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>
              <ng-select *ngIf="isTeam_selected_list" [items]="team_selected_list" bindLabel="name" bindValue="_id"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="team_selected_list_data"
                [ngModelOptions]="{ standalone: true }">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeamList ">
              <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id" placeholder="Select Team"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectTeam"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenTeam($event)"
                (close)="onDropdownCloseTeam($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionTeam()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionTeam(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeam_selected_list">
            <ng-select *ngIf="isTeam_selected_list"
              [items]="team_selected_list"
              bindLabel="name"
              bindValue="_id"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="team_selected_list_data"
              [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
          </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isStudentList || isBatchList && !isEmployee">
              <ng-select *ngIf="!isBatch_selected_list" [items]="studentList" bindLabel="name" bindValue="id"
                placeholder="Select Student" [(ngModel)]="selectedStudent" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenStudent($event)"
                (close)="onDropdownCloseStudent($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionStudent()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionStudent(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items">
                  <div class="selected-items">
                    <ng-container *ngFor="let item of items; let i = index">
                      <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                    </ng-container>
                    <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                  </div>
                </ng-template>
              </ng-select>
              <ng-select *ngIf="isBatch_selected_list" [items]="batch_selected_list" bindLabel="name" bindValue="_id"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="batch_selected_list_data"
                [ngModelOptions]="{ standalone: true }">
              </ng-select>

            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatchList && !isEmployee">
              <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                [(ngModel)]="selectedBatch" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenBatch($event)"
                (close)="onDropdownCloseBatch($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionBatch()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionBatch(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>

            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatch_selected_list">
          <ng-select
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
        </fieldset> -->
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isScheduleList">
          <ng-select
                [items]="scheduleList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeScheduleId($event)"
              >
          </ng-select>
          
        </fieldset> -->
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isPriorityList">
          <ng-select
            [items]="task_priority_List"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Priority"
            [(ngModel)]="selected_task_priority"
            [ngModelOptions]="{ standalone: true }"
            (change)="getChangeTaskPriority($event)"
          >
          </ng-select>
          
        </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isType">
              <ng-select [items]="typeList" bindLabel="name" bindValue="id" placeholder="Select Type"
                [(ngModel)]="selectedType" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTypeId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isProjectList && !isCheckList && !isLeadType">
              <ng-select [items]="project_list" bindLabel="name" bindValue="_id" placeholder="Select Project"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_project"
                [ngModelOptions]="{ standalone: true }" (change)="getProjectId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isCheckList && !isProjectList && !isLeadType">
              <ng-select [items]="check_list" bindLabel="name" bindValue="_id" placeholder="Select check"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_checklist"
                [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isLeadType && !isCheckList && !isProjectList">
              <ng-select [items]="leads_type" bindLabel="name" bindValue="id" placeholder="Select Lead"
                [(ngModel)]="select_leadType" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getLeadTypeId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isTrainingLead && !isOutsourceLead && !isCheckList && !isProjectList">
              <ng-select [items]="training_list" bindLabel="title" bindValue="_id" placeholder="Select Training"
                [(ngModel)]="select_training_lead" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getTrainingLeadId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isOutsourceLead && !isTrainingLead && !isCheckList && !isProjectList">
              <ng-select [items]="outsource_list" bindLabel="leads.title" bindValue="_id" placeholder="Select Outsource"
                [(ngModel)]="select_outsource_lead" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getOutsourceLeadId($event)">
              </ng-select>
            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTaskLabel">
          <ng-select
                [items]="taskLabelList"
                bindLabel="displayname"
                bindValue="_id"
                placeholder="Select TaskLabel"
                [(ngModel)]="selectedTaskLabel"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTaskLabelId($event)"
              >
          </ng-select>
          
        </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-edit-2"></i>
              </div>
              <input type="text" formControlName="title" class="form-control" id="todoTitle" placeholder="Title"
                (keydown.enter)="$event.preventDefault()" required #todoTitle>
              <div class="form-control-position control-position-right">
                <i class="ft-edit-2"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-message-square"></i>
              </div>
              <textarea formControlName="body" class="form-control" placeholder="body">
              <div class="form-control-position control-position-right">
                <i class="ft-message-square"></i>
              </div>
            </textarea>
            </fieldset>
            <!-- <fieldset *ngIf="isMandatory">
              <ng-select
              [items]="mandatoryList"
              bindLabel="name"
              bindValue="id"
              placeholder="Select Mandatory"
              [(ngModel)]="selectedMandatory"
              [closeOnSelect]="false"
              [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>
            </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="fa-regular fa-calendar-days"></i>
              </div>
              <input type="date" formControlName="due_date" [(ngModel)]="current_date" class="form-control">
              <div class="form-control-position control-position-right">
                <i class="fa-regular fa-calendar-days"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-clock"></i>
              </div>
              <input type="text" formControlName="time" [(ngModel)]="time" class="form-control">
              <div class="form-control-position control-position-right">
                <i class="ft-clock"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-dollar-sign"></i>
              </div>
              <input type="text" formControlName="budget" [(ngModel)]="budget_val" class="form-control"
                placeholder="Enter budget">
              <div class="form-control-position control-position-right">
                <i class="ft-dollar-sign"></i>
              </div>
            </fieldset>
          </div>
        </form>

      </div>
    </div>
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
      <button type="button" class="btn btn-primary" (click)="createTask(formRef)">Create</button>
    </div>
  </ng-template>
</div>

<!----- Add Demo Task Popup ----------->
<div>
  <ng-template #demoTask_modal let-modal>
    <div class="modal-header">
      <h3>Create Demo</h3>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-body taskboard-modal">
        <form [formGroup]="myForm">
          <div class="container">
            <div class="d-flex icons-list">
              <div class="dropdown mr-2">
                <i class="fa-solid fa-user-tie fa-xl cursor-pointer" placement="top"
                  [ngClass]="{'active-icon': isEmpList }" [ngbTooltip]="task_for_selected" id="dropdownMenuButton"
                  data-toggle="dropdown" (click)="isDropdownOpen = !isDropdownOpen; isEmpList = !isEmpList"></i>

                <!-- <div class="dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="dropdownMenuButton">
                    <span class="dropdown-item"  (click)="toggleActiveStudent('student'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Student</span>
                    </span>
                    <span class="dropdown-item" (click)="toggleActiveStudent('emp'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Employee</span>
                    </span>
                  </div> -->
              </div>
              <div class="dropdown mr-1">
                <i class="fa-solid fa-user-graduate fa-xl cursor-pointer" placement="top"
                  [ngClass]="{'active-icon': isStudentList }" id="dropdownMenuButton-demo" data-toggle="dropdown"
                  (click)="isDropdownOpen = !isDropdownOpen ; isStudentList = !isStudentList"></i>
                <!-- <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isStudentList}" placement="top" ngbTooltip="individual" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isStudentList && !isBatchList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <i class="fas fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isBatchList}" placement="top" ngbTooltip="batch" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isBatchList && !isStudentList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" *ngIf="isStudent" [class.show]="isDropdownOpen_student">
                  <a class="dropdown-item" *ngIf="!isStudentList" (click)="toggleActive('student-ind'); isDropdownOpen_student = false">Individual</a>
                  <a class="dropdown-item" *ngIf="!isBatchList" (click)="toggleActive('student-batch') ; isDropdownOpen_student = false">Batch</a>
                </div> -->
              </div>
              <!-- <div class="dropdown mr-2">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isEmpList}" placement="top" ngbTooltip="individual"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isEmpList && !isTeamList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <i class="fa-solid fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isTeamList}" placement="top" ngbTooltip="team"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isTeamList && !isEmpList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3" *ngIf="isEmployee" [class.show]="isDropdownOpen_employee">
                  <a class="dropdown-item" *ngIf="!isEmpList" (click)="toggleActive('emp-ind')">Individual</a>
                  <a class="dropdown-item" *ngIf="!isTeamList" (click)="toggleActive('emp-team')">Team</a>
                </div>
              </div> -->
              <!-- <div class="dropdown mr-2" >
                <span class="icon mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isScheduleList || selectedSchedule}" (click)="isScheduleList = !isScheduleList" placement="top" ngbTooltip="schedule" id="scheduleList" data-toggle="dropdown" ><i class="fa-solid fa-calendar-days fa-xl"></i></span>
                <div class="dropdown-menu hide-scroll" aria-labelledby="scheduleList">
                  <a class="dropdown-item" *ngFor="let item of scheduleList" [class.active]="item.id === selectedSchedule">
                    <span (click)="getChangeScheduleId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isPriorityList || selected_task_priority}" (click)="isPriorityList = !isPriorityList" placement="top" ngbTooltip="priority" id="priorityList" data-toggle="dropdown"><i class="fa-solid fa-layer-group fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="priorityList">
                  <a class="dropdown-item" *ngFor="let item of task_priority_List" [class.active]="item._id === selected_task_priority">
                    <span (click)="getChangeTaskPriority(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': selectedType}" (click)="isType = !isType" placement="top" ngbTooltip="Type"><i class="ft-grid fa-xl"></i></span>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isTaskLabel || selectedTaskLabel}" (click)="isTaskLabel = !isTaskLabel" placement="top" ngbTooltip="task label" id="task_labelList" data-toggle="dropdown"><i class="ft-tag fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="task_labelList">
                  <a class="dropdown-item" *ngFor="let item of taskLabelList" [class.active]="item._id === selectedTaskLabel">
                    <span (click)="getChangeTaskLabelId(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div> -->
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer"
                  [ngClass]="{'active-icon-danger': isMandatory || selectedMandatory}"
                  (click)="isMandatory = !isMandatory" placement="top" ngbTooltip="mandatory" id="mandatoryList"
                  data-toggle="dropdown"><i class="ft-alert-circle fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="mandatoryList">
                  <a class="dropdown-item" *ngFor="let item of mandatoryList"
                    [class.active]="item.id === selectedMandatory">
                    <span (click)="getChangeMandatoryId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>

            </div>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isEmpList || isTeamList ">
              <ng-select *ngIf="!isTeam_selected_list" [items]="empList" bindLabel="name" bindValue="_id"
                placeholder="Select Employee" [(ngModel)]="selectedEmp" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenEmp($event)"
                (close)="onDropdownCloseEmp($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionEmp()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionEmp(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>
              <ng-select *ngIf="isTeam_selected_list" [items]="team_selected_list" bindLabel="name" bindValue="_id"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="team_selected_list_data"
                [ngModelOptions]="{ standalone: true }">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeamList ">
              <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id" placeholder="Select Team"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectTeam"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenTeam($event)"
                (close)="onDropdownCloseTeam($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionTeam()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionTeam(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeam_selected_list">
            <ng-select *ngIf="isTeam_selected_list"
              [items]="team_selected_list"
              bindLabel="name"
              bindValue="_id"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="team_selected_list_data"
              [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
          </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isStudentList || isBatchList && !isEmployee">
              <ng-select *ngIf="!isBatch_selected_list" [items]="studentList" bindLabel="name" bindValue="id"
                placeholder="Select Student" [(ngModel)]="selectedStudent" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenStudent($event)"
                (close)="onDropdownCloseStudent($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionStudent()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionStudent(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items">
                  <div class="selected-items">
                    <ng-container *ngFor="let item of items; let i = index">
                      <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                    </ng-container>
                    <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                  </div>
                </ng-template>
              </ng-select>
              <ng-select *ngIf="isBatch_selected_list" [items]="batch_selected_list" bindLabel="name" bindValue="_id"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="batch_selected_list_data"
                [ngModelOptions]="{ standalone: true }">
              </ng-select>

            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatchList && !isEmployee">
              <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                [(ngModel)]="selectedBatch" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenBatch($event)"
                (close)="onDropdownCloseBatch($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionBatch()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionBatch(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>

            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatch_selected_list">
          <ng-select
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
        </fieldset> -->
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isScheduleList">
          <ng-select
                [items]="scheduleList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeScheduleId($event)"
              >
          </ng-select>
          
        </fieldset> -->
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isPriorityList">
          <ng-select
            [items]="task_priority_List"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Priority"
            [(ngModel)]="selected_task_priority"
            [ngModelOptions]="{ standalone: true }"
            (change)="getChangeTaskPriority($event)"
          >
          </ng-select>
          
        </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isType">
              <ng-select [items]="typeList" bindLabel="name" bindValue="id" placeholder="Select Type"
                [(ngModel)]="selectedType" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTypeId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isProjectList && !isCheckList && !isLeadType">
              <ng-select [items]="project_list" bindLabel="name" bindValue="_id" placeholder="Select Project"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_project"
                [ngModelOptions]="{ standalone: true }" (change)="getProjectId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isCheckList && !isProjectList && !isLeadType">
              <ng-select [items]="check_list" bindLabel="name" bindValue="_id" placeholder="Select check"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_checklist"
                [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isLeadType && !isCheckList && !isProjectList">
              <ng-select [items]="leads_type" bindLabel="name" bindValue="id" placeholder="Select Lead"
                [(ngModel)]="select_leadType" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getLeadTypeId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isTrainingLead && !isOutsourceLead && !isCheckList && !isProjectList">
              <ng-select [items]="training_list" bindLabel="title" bindValue="_id" placeholder="Select Training"
                [(ngModel)]="select_training_lead" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getTrainingLeadId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left"
              *ngIf="isOutsourceLead && !isTrainingLead && !isCheckList && !isProjectList">
              <ng-select [items]="outsource_list" bindLabel="leads.title" bindValue="_id" placeholder="Select Outsource"
                [(ngModel)]="select_outsource_lead" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getOutsourceLeadId($event)">
              </ng-select>
            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTaskLabel">
          <ng-select
                [items]="taskLabelList"
                bindLabel="displayname"
                bindValue="_id"
                placeholder="Select TaskLabel"
                [(ngModel)]="selectedTaskLabel"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTaskLabelId($event)"
              >
          </ng-select>
          
        </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-edit-2"></i>
              </div>
              <input type="text" formControlName="title" class="form-control" id="todoTitle" placeholder="Title"
                (keydown.enter)="$event.preventDefault()" required #todoTitle>
              <div class="form-control-position control-position-right">
                <i class="ft-edit-2"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-message-square"></i>
              </div>
              <textarea formControlName="body" class="form-control" placeholder="body">
              <div class="form-control-position control-position-right">
                <i class="ft-message-square"></i>
              </div>
            </textarea>
            </fieldset>
            <!-- <fieldset *ngIf="isMandatory">
              <ng-select
              [items]="mandatoryList"
              bindLabel="name"
              bindValue="id"
              placeholder="Select Mandatory"
              [(ngModel)]="selectedMandatory"
              [closeOnSelect]="false"
              [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>
            </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="fa-regular fa-calendar-days"></i>
              </div>
              <input type="date" formControlName="due_date" [(ngModel)]="current_date" class="form-control">
              <div class="form-control-position control-position-right">
                <i class="fa-regular fa-calendar-days"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-clock"></i>
              </div>
              <input type="text" formControlName="time" [(ngModel)]="time" class="form-control">
              <div class="form-control-position control-position-right">
                <i class="ft-clock"></i>
              </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mt-2">
              <div class="form-control-position">
                <i class="ft-dollar-sign"></i>
              </div>
              <input type="text" formControlName="budget" [(ngModel)]="budget_val" class="form-control"
                placeholder="Enter budget">
              <div class="form-control-position control-position-right">
                <i class="ft-dollar-sign"></i>
              </div>
            </fieldset>
          </div>
        </form>

      </div>
    </div>
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
      <button type="button" class="btn btn-primary" (click)="createTask(formRef)">Create</button>
    </div>
  </ng-template>
</div>
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>


<!-- Save Filter Modal -->
<div>
  <ng-template #filterModal let-modal>
    <div class="modal-header">
      <h3>Save Filter</h3>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-body taskboard-modal">
        <form [formGroup]="myForm">
          <div class="container">
            <fieldset class="form-group position-relative has-icon-left">
              <div class="form-control-position">
                <i class="ft-edit-2"></i>
              </div>
              <input type="text" formControlName="title" class="form-control" id="todoTitle" placeholder="Title"
                (keydown.enter)="$event.preventDefault()" required #todoTitle>
              <div class="form-control-position control-position-right">
                <i class="ft-edit-2"></i>
              </div>
            </fieldset>

            <!-- <div class="d-flex icons-list">
              <div class="dropdown mr-2">
                <button class="btn" [ngClass]="{'btn-primary': task_for_selected === 'employee', 'btn-outline-primary': task_for_selected !== 'employee'}"
                 (click)="task_for_selected = 'employee'; isSubOptionVisible = true; activeSubOption = 'team'">Employee</button>
                
                <button class="btn" [ngClass]="{'btn-primary': task_for_selected === 'student', 'btn-outline-primary': task_for_selected !== 'student'}"
                 (click)="task_for_selected = 'student'; isSubOptionVisible = true; activeSubOption = 'batch'">Student</button>
              </div>
              
              <div class="dropdown mr-2" *ngIf="isSubOptionVisible">
                <button *ngIf="task_for_selected === 'employee'" class="btn" [ngClass]="{'btn-primary': activeSubOption === 'team', 'btn-outline-primary': activeSubOption !== 'team'}" (click)="toggleActive('team')">Team</button>
                <button *ngIf="task_for_selected === 'student'" class="btn" [ngClass]="{'btn-primary': activeSubOption === 'batch', 'btn-outline-primary': activeSubOption !== 'batch'}" (click)="toggleActive('batch')">Batch</button>
              </div>
            </div> -->
            <!-- <fieldset class="form-group position-relative has-icon-left" >
              <label>Employee</label>
              <ng-select [items]="empList" bindLabel="name" bindValue="_id"
                placeholder="Select Employee" [(ngModel)]="selectedEmp" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenEmp($event)"
                (close)="onDropdownCloseEmp($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionEmp()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionEmp(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select> -->
              <!-- <ng-select  [items]="team_selected_list" bindLabel="name" bindValue="_id"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="team_selected_list_data"
                [ngModelOptions]="{ standalone: true }">
              </ng-select> -->
            <!-- </fieldset> -->

            <fieldset class="form-group">
              <label>Priority</label>
              <ng-select [items]="task_priority_List" bindLabel="displayname" bindValue="_id"
                placeholder="Select Priority" [(ngModel)]="selected_task_priority"
                [ngModelOptions]="{ standalone: true }" (change)="getChangeTaskPriority($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group">
              <label>Schedule</label>
              <ng-select [items]="scheduleList" bindLabel="name" bindValue="id" placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule_filter" [ngModelOptions]="{ standalone: true }" (change)="getChangeScheduleId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group">
              <label>Stage</label>
              <ng-select [items]="task_stage_list" bindLabel="displayname" bindValue="_id"
                placeholder="Select Stage" [(ngModel)]="selected_stage_id"
                [ngModelOptions]="{ standalone: true }" (change)="getStageId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group">
              <label>Label</label>
              <ng-select [items]="taskLabelList" bindLabel="displayname" bindValue="_id"
                placeholder="Select Label" [(ngModel)]="selectedTaskLabel"
                [ngModelOptions]="{ standalone: true }" (change)="getChangeTaskLabelId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group">
              <label>Mandatory</label>
              <ng-select [items]="mandatoryList" bindLabel="name" bindValue="id"
                placeholder="Select Mandatory" [(ngModel)]="selectedMandatory"
                [ngModelOptions]="{ standalone: true }" (change)="getChangeMandatoryId($event)">
              </ng-select>
            </fieldset>
            <!-- <fieldset class="form-group position-relative has-icon-left" >
              <label>Team</label>
              <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id" placeholder="Select Team"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectTeam"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenTeam($event)"
                (close)="onDropdownCloseTeam($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionTeam()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionTeam(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </fieldset> -->
            <!-- <fieldset class="form-group position-relative has-icon-left">
              <label>Student</label>
              <ng-select  [items]="studentList" bindLabel="name" bindValue="id"
                placeholder="Select Student" [(ngModel)]="selectedStudent" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenStudent($event)"
                (close)="onDropdownCloseStudent($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionStudent()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionStudent(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items">
                  <div class="selected-items">
                    <ng-container *ngFor="let item of items; let i = index">
                      <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                    </ng-container>
                    <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                  </div>
                </ng-template>
              </ng-select> -->
              <!-- <ng-select [items]="batch_selected_list" bindLabel="name" bindValue="_id"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="batch_selected_list_data"
                [ngModelOptions]="{ standalone: true }">
              </ng-select> -->

            <!-- </fieldset>
            <fieldset class="form-group position-relative has-icon-left">
              <label>Batch</label>
              <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                [(ngModel)]="selectedBatch" [multiple]="true" [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenBatch($event)"
                (close)="onDropdownCloseBatch($event)">
                <ng-template ng-header-tmp>
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                      (click)="toggleAllSelectionBatch()">
                    <span>Select All</span>
                  </div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="checkbox-container">
                    <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                      (change)="toggleSelectionBatch(item)">
                    <span>{{ item.name }}</span>
                  </div>
                </ng-template>
              </ng-select>

            </fieldset> -->
            <fieldset class="form-group position-relative has-icon-left" >
              <label>Type</label>
              <ng-select [items]="typeList" bindLabel="name" bindValue="id" placeholder="Select Type"
                [(ngModel)]="selectedType" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTypeId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isProjectList">
              <label>Project</label>
              <ng-select [items]="project_list" bindLabel="name" bindValue="_id" placeholder="Select Project"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_project"
                [ngModelOptions]="{ standalone: true }" (change)="getProjectId($event)">
              </ng-select>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left" *ngIf="isCheckList">
              <label>Checklist</label>
              <ng-select [items]="check_list" bindLabel="name" bindValue="_id" placeholder="Select checklist"
                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_checklist"
                [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)">
              </ng-select>
            </fieldset>
            <div *ngIf="isLeadType">
              <fieldset class="form-group position-relative has-icon-left">
                <label>Lead</label>
                <ng-select [items]="leads_type" bindLabel="name" bindValue="id" placeholder="Select Lead"
                  [(ngModel)]="select_leadType" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                  (change)="getLeadTypeId($event)">
                </ng-select>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left" *ngIf="isTrainingLead">
                <label>Training Lead</label>
                <ng-select [items]="training_list" bindLabel="title" bindValue="_id" placeholder="Select Training"
                  [(ngModel)]="select_training_lead" [multiple]="true" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                  (change)="getTrainingLeadId($event)">
                </ng-select>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left" *ngIf="isOutsourceLead">
                <label>Outsource Lead</label>
                <ng-select [items]="outsource_list" bindLabel="leads.title" bindValue="_id" placeholder="Select Outsource"
                  [(ngModel)]="select_outsource_lead" [multiple]="true" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                  (change)="getOutsourceLeadId($event)">
                </ng-select>
              </fieldset>
            </div>
            
          </div>
        </form>

      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveFilter()">Submit</button>
    </div>
  </ng-template>
</div>
